export default __webpack_public_path__ + "static/john-wines-bcbab88e27dfdf177441ae55bea88096.png";